/** Base para errores reconocibles del dominio stock (UI puede mapear por `code`). */
export class StockDomainError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = new.target.name;
    this.code = code;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

function stockErrorClass(name: string, code: string, defaultMessage: string) {
  return class extends StockDomainError {
    constructor(message = defaultMessage) {
      super(code, message);
      this.name = name;
    }
  };
}

export const NonInventoriableProductError = stockErrorClass(
  'NonInventoriableProductError',
  'NON_INVENTORIABLE_PRODUCT',
  'Los servicios no llevan stock. Usálos desde Catálogo o el POS.'
);

export const StockProductNotFoundError = stockErrorClass(
  'StockProductNotFoundError',
  'STOCK_PRODUCT_NOT_FOUND',
  'No encontramos el producto en el catálogo.'
);

export class StockInsufficientError extends StockDomainError {
  constructor(message: string) {
    super('STOCK_INSUFFICIENT', message);
    // Nombre estable: `new.target.name` se minifica en prod (Sentry veía `s:` → VUELTO-NEGOCIO-34).
    this.name = 'StockInsufficientError';
  }
}

export class StockTransferValidationError extends StockDomainError {
  constructor(message: string) {
    super('STOCK_TRANSFER_VALIDATION', message);
    this.name = 'StockTransferValidationError';
  }
}

export const StockTransferNotFoundError = stockErrorClass(
  'StockTransferNotFoundError',
  'STOCK_TRANSFER_NOT_FOUND',
  'No encontramos esa transferencia. Puede que ya la hayan recibido.'
);

export class StockReceiveValidationError extends StockDomainError {
  constructor(message: string) {
    super('STOCK_RECEIVE_VALIDATION', message);
    this.name = 'StockReceiveValidationError';
  }
}
